import React from 'react';

// Context to pass grid list style to child text blocks
export const GridListStyleContext = React.createContext({
  gridListStyle: null,
});

export const GridListStyleProvider = GridListStyleContext.Provider;
export const useGridListStyle = () => React.useContext(GridListStyleContext);
